var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBloqueio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2089 0.294922H8.77922L0 9.0816V21.5082L8.78514 30.2949H21.2149L30 21.5082V9.0816L21.2089 0.294922Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8872 11.4416H19.0745V9.81046C19.0745 7.56003 17.2502 5.73535 15.0002 5.73535C12.7502 5.73535 10.9259 7.56556 10.9259 9.81599V11.4471H10.1133C9.21768 11.4471 8.48242 12.1825 8.48242 13.0783V21.223C8.48242 22.1187 9.21768 22.8541 10.1133 22.8541H19.8872C20.7827 22.8541 21.518 22.1187 21.518 21.223V13.0728C21.518 12.177 20.7827 11.4416 19.8872 11.4416ZM17.5266 11.4416H12.4738V9.81046C12.4738 8.41707 13.6071 7.28356 15.0002 7.28356C16.3933 7.28356 17.5266 8.41707 17.5266 9.81046V11.4416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBloqueio);
export default __webpack_public_path__ + "static/media/bloqueio.ad1a01fcffe281ea943c9b8543cac738.svg";
export { ForwardRef as ReactComponent };